export function format(num, option) {
  let base = parseFloat(num);

  if (isNaN(base) || base === 0) {
    return '0';
  }

  const reg = /(^[+-]?\d+)(\d{3})/;
  const addCommas = n => {
    let base = n + '';
    while (reg.test(base)) {
      base = base.replace(reg, '$1,$2');
    }

    return base;
  };

  if (option === 'kr') {
    let postfix = '';
    if (base >= 10000) {
      base = parseInt(base / 10000);
      postfix = '만';
    }

    return addCommas(base) + postfix;
  } else {
    return addCommas(base);
  }
}

export function tel(num) {
  return num.replace(/(02|\d{3})(\d{3,4})(\d{4})/, '$1-$2-$3');
}



// WEBPACK FOOTER //
// ./src/utils/FormatUtils.js